import React, { useEffect, useState } from 'react';
// @ts-ignore: allow side-effect CSS import without type declarations

import './Blog.css';
import Header from '../../componets/header/header';
import Footer from '../../componets/footer/footer';
import blog10 from '../../../assets/blog-10.webp';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';

function Blog10() {
    const navigate = useNavigate();
    const [openSection, setOpenSection] = useState<string | null>(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const toggleSection = (section: string) => {
        setOpenSection(prev => (prev === section ? null : section));
    };
    const [expandedCards, setExpandedCards] = useState<{ [key: number]: boolean }>({});

    const toggleReadMore = (index: number) => {
        setExpandedCards((prev) => ({
            ...prev,
            [index]: !prev[index]
        }));
    };
    return (
        <>
            <Header />
            <div className="about-page">
                <div className="blog-container">
                    <div className="blog-images">
                        <img src={blog10} alt="IFRS Blog" />
                    </div>

                    <h1>IFRS Diploma: The Ultimate Guide to Global Accounting Careers, Salary & Job Opportunities</h1>

                    <p>
                        In today’s <b>hyper-globalized business environment</b>, International Financial Reporting
                        Standards (IFRS) are <b>no longer optional</b> they are <b>mandatory knowledge</b> for accounting and
                        finance professionals.
                    </p>

                    <p>
                        From <b>multinational corporations (MNCs) </b>and <b>Big 4 firms</b> to <b>global banks, consulting
                            companies, and overseas employers,</b> IFRS expertise has become a <b>core hiring requirement</b>.
                    </p>

                    <p>
                        Whether you are a <b>B.Com student, CA aspirant, CMA, ACCA/CPA candidate, working
                            accountant, auditor, or finance professional,</b> mastering IFRS can <b>transform your career,</b>
                        unlock <b>high-paying global jobs</b>, and <b>future-proof your professional journey.</b>
                    </p>
                    <p>
                        This <b>ultimate IFRS guide</b> explains everything a student or professional must know before
                        choosing an IFRS course in <b>Kochi, Kerala, India</b>.
                    </p>
                    <h2>What This IFRS Guide Covers</h2>
                    <ul>
                        <li>IFRS meaning & full form</li>
                        <li>What is a Diploma in IFRS</li>
                        <li>IFRS syllabus & exam structure</li>
                        <li>IFRS jobs, career scope & salary (India & abroad)</li>
                        <li>IFRS vs GAAP vs Ind AS</li>
                        <li>Who should study IFRS</li>
                        <li>Why IFRS is mandatory for accounting & finance careers</li>
                        <li>Why <b>Meantoir Global Academy is India’s FIRST & ONLY institute </b>offering <b>IFRS from IQN UK</b></li>
                        <li>Best IFRS institute in <b>Kochi, Kerala, India</b></li>
                    </ul>

                    <h2>What Is IFRS? (Meaning & Full Form)</h2>
                    <p><b>IFRS full form is International Financial Reporting Standards. </b></p>
                    <p>
                        IFRS is a globally accepted set of accounting standards issued by the <b>International Accounting
                            Standards Board (IASB)</b> to ensure:
                    </p>


                    <ul>
                        <li>Transparency</li>
                        <li>Consistency</li>
                        <li>Comparability</li>
                        <li>Reliability of financial statements</li>

                    </ul>
                    <p>Across borders and jurisdictions. </p>
                    <p>

                        Today,<b> 140+ countries</b> follow IFRS or IFRS-converged standards, making IFRS the <b>globallanguage of accounting and financial reporting.
                            language of accounting and financial reporting.</b>
                    </p>
                    <h2>Who Should Take the IFRS Course?</h2>
                    <ul>
                        <li>CA, CMA, ACCA, CPA, CS</li>
                        <li>B.Com / M.Com graduates</li>
                        <li>MBA (Finance) students</li>
                        <li>Auditors & consultants</li>
                        <li>Freshers & working professionals</li>
                    </ul>
                    <h2>Why IFRS Knowledge Is Mandatory for Accounting &
                        Finance Professionals </h2>
                    <p>As stated by <b>Mr. Sebin Sebastian, CEO & Academic Head – Meantoir Global Academy: </b></p>
                    <p><i>“IFRS is no longer optional knowledge. It is mandatory for every accounts and finance
                        professional, irrespective of the domain.”</i></p>
                    <h2>Why IFRS Is Important Today </h2>

                    <ul>
                        <li>Mandatory for<b> MNC finance roles </b></li>
                        <li>Strongly preferred by <b>Big 4 firms </b>(Deloitte, PwC, EY, KPMG)</li>
                        <li>Essential for <b>international accounting & reporting </b></li>
                        <li>Enables <b>global career mobility </b></li>
                        <li>Required for <b>consolidation, group accounts & cross-border reporting</b></li>
                        <li>Improves <b>professional credibility, salary growth & promotions</b></li>
                    </ul>
                    <p>Professionals without IFRS knowledge are increasingly <b>filtered out</b> during hiring. </p>
                    <h2>IFRS vs GAAP vs Ind AS – Key Differences</h2>

                    <table className="ifrs-table">
                        <thead>
                            <tr>
                                <th>Standard</th>
                                <th>Nature</th>
                                <th>Usage</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>IFRS</td>
                                <td>Principle-based</td>
                                <td>Global (140+ countries)</td>
                            </tr>
                            <tr>
                                <td>US GAAP</td>
                                <td>Rule-based</td>
                                <td>United States</td>
                            </tr>
                            <tr>
                                <td>Ind AS</td>
                                <td>IFRS-converged</td>
                                <td>India</td>
                            </tr>
                        </tbody>
                    </table>

                    <p>Professionals trained in IFRS standards gain a clear advantage in:</p>
                    <ul>
                        <li>Multinational reporting</li>
                        <li>Mergers & acquisitions</li>
                        <li>Group accounts & consolidation</li>
                        <li>Overseas audits & compliance</li>
                    </ul>

                    <h2>What Is an IFRS Course?</h2>
                    <p>An IFRS course is a professional certification program that trains individuals in:</p>
                    <ul>
                        <li>IFRS standards & conceptual framework</li>
                        <li>Financial statement preparation</li>
                        <li>Group accounts & consolidation</li>
                        <li>Disclosures & compliance</li>
                        <li>International accounting practices</li>
                    </ul>

                    <p>
                        Among all IFRS qualifications, the <strong>Diploma in IFRS</strong> is the most globally respected
                        and industry-oriented certification.
                    </p>

                    <h2>Diploma in IFRS from IQN UK - Offered Exclusively by Meantoir Global Academy</h2>
                    <p><strong>⭐ FIRST & ONLY IN INDIA ⭐</strong></p>
                    <p>
                        Meantoir Global Academy is the FIRST and ONLY educational institute in India offering
                        the Diploma in IFRS from IQN UK (International Qualifications Network, United Kingdom).
                    </p>
                    <p><strong>⚠️ No other institute in India offers IFRS from IQN UK</strong></p>

                    <h3>About IFRS Certification from IQN UK</h3>
                    <ul>
                        <li>UK-based professional qualification</li>
                        <li>Globally recognized</li>
                        <li>Industry-oriented</li>
                        <li>Practical & case-study driven</li>
                        <li>Exam-focused, not theory-heavy</li>
                    </ul>
                    <p>This makes it one of the most powerful IFRS certifications in India.</p>

                    <h2>Why Choose IFRS Course from IQN UK via Meantoir Global Academy?</h2>
                    <ul>
                        <li>IFRS Certification from the UK (IQN)</li>
                        <li>Recognition across 180+ countries</li>
                        <li>Live interactive online classes (not recorded videos)</li>
                        <li>Faculty with real-world IFRS experience</li>
                        <li>Strong focus on practical application</li>
                        <li>Case studies & real financial statements</li>
                        <li>Exam-oriented preparation</li>
                        <li>Career guidance & placement support</li>
                    </ul>

                    <p>
                        Meantoir Global Academy is a trusted IFRS training institute in Ernakulam, Kochi, Kerala & India
                    </p>

                    <h2>Who Should Take the IFRS Course?</h2>
                    <p>The IFRS course for accountants and finance professionals is ideal for:</p>
                    <ul>
                        <li>Chartered Accountants (CA)</li>
                        <li>CMA / Cost Accountants</li>
                        <li>ACCA & CPA aspirants</li>
                        <li>Company Secretaries (CS)</li>
                        <li>B.Com / M.Com graduates</li>
                        <li>MBA (Finance) students</li>
                        <li>Auditors & consultants</li>
                        <li>Finance managers & analysts</li>
                        <li>Freshers seeking global exposure</li>
                        <li>Working professionals targeting MNC roles</li>
                    </ul>

                    <p>✔️ IFRS certification for freshers</p>
                    <p>✔️ IFRS certification for working professionals</p>
                    <p>Both offer high long-term ROI.</p>

                    <h2>Diploma in IFRS - Syllabus Overview</h2>
                    <p>The Diploma in IFRS syllabus combines theory + real-world application.</p>

                    <h3>Key Modules Covered</h3>
                    <p><strong>Conceptual Framework</strong></p>
                    <ul>
                        <li>IASB framework</li>
                        <li>IFRS Foundation</li>
                    </ul>

                    <p><strong>Core IFRS & IAS Standards</strong></p>
                    <ul>
                        <li>IAS 1 – Presentation of Financial Statements</li>
                        <li>IFRS 15 – Revenue from Contracts with Customers</li>
                        <li>IFRS 16 – Leases</li>
                        <li>IFRS 9 – Financial Instruments</li>
                        <li>IFRS 13 – Fair Value Measurement</li>
                        <li>IAS 2 – Inventories</li>
                        <li>IAS 12 – Income Taxes</li>
                        <li>IAS 16 – Property, Plant & Equipment</li>
                    </ul>

                    <p><strong>Group Accounts</strong></p>
                    <ul>
                        <li>Consolidation principles</li>
                        <li>Subsidiaries, associates & joint ventures</li>
                    </ul>

                    <p><strong>Disclosures</strong></p>
                    <ul>
                        <li>IFRS-compliant disclosures</li>
                        <li>Notes to accounts</li>
                    </ul>

                    <p><strong>Ethics</strong></p>
                    <ul>
                        <li>Professional & ethical standards</li>
                    </ul>

                    <h2>IFRS Exam Pattern (IQN UK)</h2>
                    <ul>
                        <li>Single paper exam</li>
                        <li>Duration: 3 hours</li>
                        <li>4 compulsory case-study questions</li>
                        <li>25 marks each</li>
                        <li>Passing mark: 50%</li>
                        <li>Essay-based answers</li>
                        <li>Partial marking available</li>
                    </ul>

                    <h2>Meantoir’s Proven 3-Month Success Strategy</h2>
                    <ul>
                        <li>2 hours daily study plan</li>
                        <li>Structured revision & mock exams</li>
                        <li>If a student attends classes and follows the plan but doesn’t pass, Re-attendance is allowed FREE</li>
                    </ul>

                    <h2>IFRS Jobs & Career Scope</h2>
                    <p>The career scope after IFRS certification is vast and rapidly growing.</p>

                    <h3>Popular IFRS Job Roles</h3>
                    <ul>
                        <li>IFRS Accountant</li>
                        <li>Financial Reporting Manager</li>
                        <li>IFRS Consultant</li>
                        <li>Consolidation Expert</li>
                        <li>Statutory Auditor</li>
                        <li>Group Accounts Controller</li>
                        <li>Finance Manager / CFO</li>
                    </ul>

                    <h3>Industries Hiring IFRS Professionals</h3>
                    <ul>
                        <li>Big 4 & audit firms</li>
                        <li>Multinational corporations</li>
                        <li>Global banks & NBFCs</li>
                        <li>Consulting & IT companies</li>
                        <li>Manufacturing & infrastructure giants</li>
                        <li>Insurance & financial services</li>
                    </ul>

                    <h2>IFRS Salary - India & Global Opportunities</h2>
                    <p><strong>India</strong></p>
                    <ul>
                        <li>Average: ₹6 LPA – ₹20+ LPA</li>
                        <li>Freshers: ₹4 – ₹8 LPA</li>
                        <li>Experienced professionals: ₹15 – ₹25+ LPA</li>
                    </ul>

                    <p><strong>Abroad (Middle East, Europe, Global MNCs)</strong></p>
                    <ul>
                        <li>USD 60,000 – 120,000+ per year</li>
                    </ul>

                    <p>Many Meantoir Global Academy alumni have achieved:</p>
                    <ul>
                        <li>50% – 100% salary hikes</li>
                        <li>Overseas placements & global roles</li>
                    </ul>

                    <h2>Is IFRS Certification Worth It?</h2>
                    <p><strong>YES. 100%.</strong></p>

                    <h3>Benefits of IFRS Certification</h3>
                    <ul>
                        <li>Global recognition</li>
                        <li>High return on investment (ROI)</li>
                        <li>Strong MNC demand</li>
                        <li>Higher salary potential</li>
                        <li>Faster career growth</li>
                        <li>Long-term job security</li>
                    </ul>

                    <h2>Future of IFRS Careers</h2>
                    <p>
                        With globalization, foreign investments, mergers, and acquisitions increasing,
                        IFRS professionals will remain in high demand.
                    </p>
                    <ul>
                        <li>Transparent financial reporting</li>
                        <li>Investor confidence</li>
                        <li>Global compliance</li>
                        <li>Economic stability</li>
                    </ul>

                    <h2>Final Conclusion: Build a Global Accounting Career with IFRS</h2>
                    <p>
                        The IFRS course is not just a qualification - It is a global career passport.
                    </p>
                    <p>If you want:</p>
                    <ul>
                        <li>MNC jobs</li>
                        <li>Overseas opportunities</li>
                        <li>High-paying finance roles</li>
                        <li>Leadership positions in accounting & finance</li>
                    </ul>

                    <p>
                        Then the <b>Diploma in IFRS from IQN UK,</b> offered exclusively by <b>Meantoir Global Academy,</b>
                        is the <b>smartest investment</b> you can make.
                    </p>

                    <ul>
                        <li>Learn IFRS </li>
                        <li>Earn UK certification </li>
                        <li>Build a future-proof global finance career </li>

                    </ul>
                    <b>Meantoir Global Academy</b>
                    <br />
                    India’s FIRST & ONLY institute offering IFRS from IQN UK
                    <br />
                    Kerala, India
                    <br />
                    <br />
                    +91-9778127403 | +91-9778127404
                    <br />
                    www.meantoir.com | 📧 info@meantoir.com

                    <div className="course-details-faq">
                        <h2 className="homepage-heading">

                            Frequently Asked Questions (FAQs) – IFRS in Kerala &
                            India </h2>
                        <div >
                            <h3 onClick={() => toggleSection("What is IFRS and why is it important in India")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                What is IFRS and why is it important in India?
                            </h3>
                            {openSection === "What is IFRS and why is it important in India" && (
                                <>
                                    <p style={{ fontSize: "1.5rem", }}>
                                        <b>IFRS (International Financial Reporting Standards)</b> are globally accepted accounting
                                        standards used in over 140 countries. In India, IFRS knowledge is essential for professionals
                                        working with <b>MNCs, Big 4 firms, global banks, and international companies,</b> as most cross
                                        border reporting follows IFRS.
                                    </p>
                                </>
                            )}
                        </div>
                        <div >
                            <h3 onClick={() => toggleSection(" Is IFRS mandatory in India? ")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                Is IFRS mandatory in India?
                            </h3>
                            {openSection === " Is IFRS mandatory in India? " && (
                                <>
                                    <p style={{ fontSize: "1.5rem", }}>

                                        IFRS is <b>not directly mandatory </b>for all Indian companies, but India follows Ind AS, which is
                                        converged with IFRS. However, <b>IFRS is mandatory for global reporting, foreign
                                            subsidiaries, overseas jobs, and MNC finance roles,</b> making IFRS certification highly valuable
                                        in India.
                                    </p>
                                </>
                            )}
                        </div>
                        <div >
                            <h3 onClick={() => toggleSection("Who should study IFRS in Kerala and India?")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                Who should study IFRS in Kerala and India?
                            </h3>
                            {openSection === "Who should study IFRS in Kerala and India?" && (
                                <>
                                    <p style={{ fontSize: "1.5rem", }}>
                                        IFRS is ideal for:
                                        <ul>
                                            <li>
                                                Accountants & Auditors
                                            </li>
                                            <li>CA, CMA, ACCA students and professionals </li>
                                            <li> Finance managers & analysts </li>
                                            <li>Commerce graduates & freshers</li>
                                            <li>Working professionals aiming for MNC or overseas jobs</li>
                                        </ul>
                                    </p>
                                </>
                            )}
                        </div>
                        <div >
                            <h3 onClick={() => toggleSection(" What are the career opportunities after IFRS certification in India?")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                What are the career opportunities after IFRS certification in India?
                            </h3>
                            {openSection === " What are the career opportunities after IFRS certification in India?" && (
                                <>
                                    <p style={{ fontSize: "1.5rem", }}>
                                        After completing IFRS certification, you can work as:
                                        <ul>
                                            <li>IFRS Accountant </li>
                                            <li>IFRS Financial Analyst </li>
                                            <li>
                                                IFRS Consultant
                                            </li>
                                            <li>IFRS Reporting Manager </li>
                                            <li>IFRS Auditor
                                            </li>
                                        </ul>
                                        <br />
                                        There is strong demand for <b>IFRS jobs in India and abroad,</b> especially in <b>Bangalore, Mumbai,
                                            Kochi, Chennai, and GCC countries.</b>
                                    </p>
                                </>
                            )}
                        </div>
                        <div >
                            <h3 onClick={() => toggleSection(" What is the salary after IFRS certification in India?")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                What is the salary after IFRS certification in India?                            </h3>
                            {openSection === " What is the salary after IFRS certification in India?" && (
                                <>
                                    <p style={{ fontSize: "1.5rem", }}>
                                        The <b>IFRS salary in India </b>typically ranges from<b>₹6 LPA to ₹20+ LPA,</b>  depending on
                                        experience and qualifications. Professionals with CA, CMA, or ACCA plus IFRS certification
                                        earn significantly higher salaries, especially in MNCs and Big 4 firms.
                                    </p>
                                </>
                            )}
                        </div>
                        <div >
                            <h3 onClick={() => toggleSection("Is IFRS certification useful for freshers in Kerala?")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                Is IFRS certification useful for freshers in Kerala?
                            </h3>
                            {openSection === "Is IFRS certification useful for freshers in Kerala?" && (
                                <>
                                    <p style={{ fontSize: "1.5rem", }}>
                                        Yes. <b>IFRS certification for freshers </b>in Kerala provides a strong foundation in <b>international
                                            accounting </b>and improves employability in <b>global companies, shared service centers, and
                                                audit firms.</b>
                                    </p>
                                </>
                            )}
                        </div>
                        <div>
                            <h3 onClick={() => toggleSection(" Which is the best IFRS course in Kerala and India? ")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                Which is the best IFRS course in Kerala and India?                             </h3>
                            {openSection === " Which is the best IFRS course in Kerala and India? " && (
                                <>
                                    <p style={{ fontSize: "1.5rem", }}>
                                        The <b>Diploma in IFRS from IQN UK offered by Meantoir Global Academy </b>is considered one
                                        of the <b>best IFRS courses in India,</b> as it is:
                                        <ul>
                                            <li>
                                                A <b>UK-based international certification</b>
                                            </li>
                                            <li>Industry-oriented and practical </li>
                                            <li>Offered by the <b>FIRST & ONLY institute in India</b> providing IFRS from IQN UK </li>
                                        </ul>
                                    </p>
                                </>
                            )}
                        </div>
                        <div>
                            <h3 onClick={() => toggleSection(" Is the IFRS course from IQN UK globally recognized? ")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                Is the IFRS course from IQN UK globally recognized?
                            </h3>
                            {openSection === " Is the IFRS course from IQN UK globally recognized? " && (
                                <>
                                    <p style={{ fontSize: "1.5rem", }}>
                                        Yes. The <b>IFRS course from IQN UK is a globally recognized international certification,</b>
                                        suitable for professionals <b>targeting MNC jobs, overseas employment, and global finance
                                            careers.</b>

                                    </p>
                                </>
                            )}
                        </div>
                        <div>
                            <h3 onClick={() => toggleSection("What is the duration of an IFRS course in India? ")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                What is the duration of an IFRS course in India?                             </h3>
                            {openSection === "What is the duration of an IFRS course in India? " && (
                                <>
                                    <p style={{ fontSize: "1.5rem", }}>
                                        Most IFRS courses in India range from <b>2 to 6 months,</b> depending on the curriculum, study mode
                                        (online or classroom), and exam structure.
                                    </p>
                                </>
                            )}
                        </div>
                        <div>
                            <h3 onClick={() => toggleSection("Can I do an IFRS course online from Kerala? ")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                Can I do an IFRS course online from Kerala?                           </h3>
                            {openSection === "Can I do an IFRS course online from Kerala? " && (
                                <>
                                    <p style={{ fontSize: "1.5rem", }}>
                                        Yes. You can pursue an <b>IFRS online course from Kerala</b> through recognized institutes like
                                        <b> Meantoir Global Academy,</b> which offers structured training with global curriculum and expert
                                        faculty.
                                    </p>
                                </>
                            )}
                        </div>
                        <div>
                            <h3 onClick={() => toggleSection("What is the difference between IFRS and Ind AS? ")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                What is the difference between IFRS and Ind AS?                           </h3>
                            {openSection === "What is the difference between IFRS and Ind AS? " && (
                                <>
                                    <p style={{ fontSize: "1.5rem", }}>
                                        <ul>
                                            <li><b>IFRS </b>is globally accepted </li>
                                            <li><b>Ind AS </b>is India’s version converged with IFRS </li>
                                        </ul>
                                        For <b>international reporting and overseas jobs, IFRS knowledge is preferred.</b>

                                    </p>
                                </>
                            )}
                        </div>
                        <div>
                            <h3 onClick={() => toggleSection("Is IFRS certification worth it in India?")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                Is IFRS certification worth it in India?                          </h3>
                            {openSection === "Is IFRS certification worth it in India?" && (
                                <>
                                    <p style={{ fontSize: "1.5rem", }}>
                                        Absolutely. IFRS certification offers:

                                        <ul>
                                            <li>Global career mobility </li>
                                            <li>High return on investment </li>
                                            <li>
                                                Strong demand in MNCs
                                            </li>
                                            <li>Better salary and job stability </li>
                                        </ul>
                                    </p>
                                </>
                            )}
                        </div>
                        <div>
                            <h3 onClick={() => toggleSection(" Does IFRS help in getting overseas jobs?")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                Does IFRS help in getting overseas jobs?                          </h3>
                            {openSection === " Does IFRS help in getting overseas jobs?" && (
                                <>
                                    <p style={{ fontSize: "1.5rem", }}>
                                        Yes. IFRS is widely used in <b>Europe, UK, Middle East, Australia, and many Asian countries.</b>
                                        IFRS certification significantly improves chances of <b>overseas accounting and finance jobs.</b>
                                    </p>
                                </>
                            )}
                        </div>
                        <div>
                            <h3 onClick={() => toggleSection("Which industries hire IFRS professionals in India?")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                Which industries hire IFRS professionals in India?                          </h3>
                            {openSection === "Which industries hire IFRS professionals in India?" && (
                                <>
                                    <p style={{ fontSize: "1.5rem", }}>
                                        <ul>
                                            <li>MNCs</li>
                                            <li>Big 4 accounting firms </li>
                                            <li>Global banks </li>
                                            <li>Consulting firms </li>
                                            <li>IT & shared service centers</li>

                                        </ul>
                                    </p>
                                </>
                            )}
                        </div>
                        <div>
                            <h3 onClick={() => toggleSection(" Is IFRS difficult to study?")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                Is IFRS difficult to study?                          </h3>
                            {openSection === " Is IFRS difficult to study?" && (
                                <>
                                    <p style={{ fontSize: "1.5rem", }}>
                                        IFRS is <b>conceptual and principle-based, </b>not difficult when taught properly. With the right
                                        training and practical approach, IFRS becomes easy to understand—even for freshers.
                                    </p>
                                </>
                            )}
                        </div>
                        <div>
                            <h3 onClick={() => toggleSection(" Why choose Meantoir Global Academy for IFRS in India?")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                Why choose Meantoir Global Academy for IFRS in India?                          </h3>
                            {openSection === " Why choose Meantoir Global Academy for IFRS in India?" && (
                                <>
                                    <p style={{ fontSize: "1.5rem", }}>
                                        <b>Meantoir Global Academy </b>is the <b>FIRST & ONLY institute in India </b>offering the
                                        <b>Diploma in
                                            IFRS from IQN UK,</b> providing:
                                        <ul>
                                            <li>Global certification </li>
                                            <li>Practical IFRS training </li>
                                            <li>Career-focused learning</li>
                                            <li>Strong industry relevance</li>
                                        </ul>
                                    </p>
                                </>
                            )}
                        </div>

                    </div>

                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '30px' }}>
                        <Button type="primary" onClick={() => navigate('/blog9')}>Previous</Button>
                        <Button type="primary" onClick={() => navigate('/blog11')}>Next</Button>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default Blog10;
